export { default } from "./UserDiagnostic.component";
